import { APP_ID, APP_NAME, B2C_AUTHORITY_DOMAIN, MAJOR_VERSION, PATCH_VERSION } from '../config/global-config';

// Per-environment settings, loaded at startup from assets/config.json (see src/environments/config.<env>.json).
export interface RuntimeConfig {
  production: boolean;
  local: boolean;

  applicationUrl: string;
  apiUrl: string;
  demoCompanyId: number | null;

  truthEngineAppUrl: string;
  trackingAppUrl: string;
  purchaseOrdersAppUrl: string;
  estimatingAppUrl: string;
  configAppUrl: string;
  adminAppUrl: string;

  authority: string;
  consentScopes: string[];
  clientID: string;
}

const buildSettings = {
  applicationTitle: APP_NAME,
  clientName: APP_NAME,
  fullVersion: MAJOR_VERSION + PATCH_VERSION,
  majorVersion: MAJOR_VERSION,
  appId: APP_ID,
  authorityDomain: B2C_AUTHORITY_DOMAIN,
};

// Runtime values are merged in by main.ts before the app bootstraps.
export const environment = { ...buildSettings } as typeof buildSettings & RuntimeConfig;
